import { combineReducers } from 'redux';
import { screenResize } from './screenResize';
import { bedStatus } from './bedStatus';
import { booking, pupBooking } from './Booking';
import SettingsReducer, { fullScreenReducer, AdmissionWorkflowReducer } from './settings';
import { loginInfo, wardInfo } from './loginInfo';
import { LoadingReducer } from './loading';
import { NoteList, FolowTotal,ehdSetting } from './ehandover';
import { dutyEditFlag } from './dutyassign';
import { userRole } from './userRole';
import { rouList } from './rouList';
import { roleMap } from './roleMap';
import { hospitalWardList } from './hospitalWardList';
import {
  notificationTotal,
  notificationTotalRefresh,
  initForwardList,
  notificationSeenAndRefresh,
} from './notification';
import { expiryLoginReducer } from './expiryLogin';
import LoginPopupReducer from './loginPopup';
import bedStatusView from './cubicleView';
import { ssoReducer, maskReducer } from './sso';
import { versionReducer } from './version';
import { ActionableSettingsReducer } from './actionable';
import { appreciationTotal } from './appreciation'
import {envReducer} from './envReducer';

export default combineReducers({
  settings: SettingsReducer,
  booking,
  pupBooking,
  bedStatus,
  screenResize,
  loginInfo,
  loading: LoadingReducer,
  NoteList,
  FolowTotal,
  wardInfo,
  dutyEditFlag,
  userRole,
  rouList,
  roleMap,
  hospitalWardList,
  notificationTotal,
  notificationTotalRefresh,
  initForwardList,
  expiryLogin: expiryLoginReducer,
  fullScreenReducer,
  LoginPopupReducer,
  bedStatusView,
  ssoReducer,
  maskReducer,
  notificationSeenAndRefresh,
  versionReducer,
  ActionableSettingsReducer,
  AdmissionWorkflowReducer,
  appreciationTotal,
  envReducer,
  ehdSetting
});
